import { render, staticRenderFns } from "./EmptyCalendarOld.vue?vue&type=template&id=542ffaf0&scoped=true"
import script from "./EmptyCalendarOld.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmptyCalendarOld.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./EmptyCalendarOld.vue?vue&type=style&index=0&id=542ffaf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542ffaf0",
  null
  
)

export default component.exports